/** Pure hulpfuncties voor het sleuteloverzicht (getest in __tests__/sleutelLogica.test.js). */

export const LEEG_FILTER = { zoek: '', status: '', profiel: '', toegang: '' };

const bevat = (tekst, q) => String(tekst || '').toLowerCase().includes(q);

/** Tab 'werkend' = alleen tags die fysiek bruikbaar zijn; daarna de filters. */
export function filterTags(tags = [], tab = 'werkend', f = LEEG_FILTER) {
  const q = String(f.zoek || '').trim().toLowerCase();
  return tags.filter((t) => {
    if (tab === 'werkend' && !t.werkend) return false;
    if (f.status && t.status !== f.status) return false;
    if (f.profiel && t.profiel !== f.profiel) return false;
    if (f.toegang && t.toegang !== f.toegang) return false;
    if (!q) return true;
    if (String(t.tag ?? '') === q.replace(/^tag\s*/, '')) return true;
    return bevat(t.naam, q) || bevat(t.opmerkingen, q)
      || [...(t.huidigeEigenaar || []), ...(t.eerdereEigenaar || [])].some((p) => bevat(p.naam, q));
  });
}

export const namen = (lijst = []) => lijst.map((p) => p.naam).join(', ');
export const ids = (lijst = []) => lijst.map((p) => p.id);

/** Alleen de gewijzigde velden (leeg = null); eigenaren als id-lijst. */
export function wijziging(oud, nieuw) {
  const body = {};
  for (const k of ['status', 'profiel', 'toegang', 'opmerkingen']) {
    const a = oud[k] ?? null; const b = nieuw[k] === '' ? null : (nieuw[k] ?? null);
    if (a !== b) body[k] = b;
  }
  const nieuwIds = ids(nieuw.huidigeEigenaar);
  if (JSON.stringify(ids(oud.huidigeEigenaar)) !== JSON.stringify(nieuwIds)) body.huidigeEigenaar = nieuwIds;
  return body;
}
